var _circle, _circle2, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg196(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.5625,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 0.875
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_159_12227",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5625 28C55.5625 43.2224 43.2224 55.5625 28 55.5625C12.7777 55.5625 0.4375 43.2224 0.4375 28C0.4375 12.7777 12.7777 0.4375 28 0.4375C43.2224 0.4375 55.5625 12.7777 55.5625 28Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.875
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_159_12227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.6372C10.5 14.2885 10.7825 14.004 11.1287 14.004H19.206C19.5521 14.004 19.8347 14.2885 19.8347 14.6372V22.7723C19.8347 23.1249 19.5521 23.4095 19.206 23.4095H11.1287C10.7825 23.4095 10.5 23.1249 10.5 22.7723V14.6372ZM19.8347 41.3668C19.8347 41.7155 19.5521 42 19.206 42H11.1287C10.7825 42 10.5 41.7155 10.5 41.3668V33.2317C10.5 32.8791 10.7825 32.5945 11.1287 32.5945H19.206C19.5521 32.5945 19.8347 32.8791 19.8347 33.2317V41.3668ZM28.5327 32.7027H20.4554C20.1092 32.7027 19.8227 32.4182 19.8227 32.0655V23.9304C19.8227 23.5818 20.1052 23.2933 20.4554 23.2933H28.5327C28.8789 23.2933 29.1653 23.5778 29.1653 23.9304V32.0655C29.1653 32.4142 28.8828 32.7027 28.5327 32.7027ZM38.5 41.3668C38.5 41.7155 38.2175 42 37.8673 42H29.79C29.4439 42 29.1614 41.7155 29.1614 41.3668V33.2317C29.1614 32.8791 29.4439 32.5945 29.79 32.5945H37.8673C38.2135 32.5945 38.5 32.8791 38.5 33.2317V41.3668ZM38.5 22.7683C38.5 23.1209 38.2175 23.4055 37.8673 23.4055H29.79C29.4439 23.4055 29.1614 23.1209 29.1614 22.7683V14.6332C29.1614 14.2845 29.4439 14 29.79 14H37.8673C38.2135 14 38.5 14.2845 38.5 14.6332V22.7683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6001 14.6372C40.6001 14.2886 40.8826 14.004 41.2288 14.004H45.1061C45.4522 14.004 45.7348 14.2886 45.7348 14.6372V22.7723C45.7348 23.125 45.4522 23.4095 45.1061 23.4095H41.2288C40.8826 23.4095 40.6001 23.125 40.6001 22.7723V14.6372ZM45.7348 41.3668C45.7348 41.7155 45.4522 42 45.1061 42H41.2288C40.8826 42 40.6001 41.7155 40.6001 41.3668V33.2317C40.6001 32.8791 40.8826 32.5946 41.2288 32.5946H45.1061C45.4522 32.5946 45.7348 32.8791 45.7348 33.2317V41.3668Z",
    fill: "white",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg196);
export default __webpack_public_path__ + "static/media/196.a8651e1852109a216e1fd928fb6ea9c2.svg";
export { ForwardRef as ReactComponent };